export default __webpack_public_path__ + "static/media/github-footer.fd3a419e.svg";